<div class="dsp-dialog" data-testid="send-proposal-dialog">

  <div class="dsp-head">
    <div class="dsp-heading">
      <h1 class="dsp-title" data-testid="dialog-title">{{ 'proposals.dialogs.sendProposal.title' | transloco }}</h1>
      <p *ngIf="data.reference" class="dsp-reference" data-testid="send-proposal-reference">{{ data.reference }}</p>
    </div>
    <button type="button" class="dsp-close" (click)="cancel()" [attr.aria-label]="'common.close' | transloco">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
    </button>
  </div>

  <div class="dsp-body">
    <div *ngIf="testRecipient && mode === 'clients'" class="dsp-test-mode" role="status" data-testid="email-test-mode-banner">
      <svg class="dsp-test-mode-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
      <span>{{ 'proposals.dialogs.sendProposal.testModeBanner' | transloco: { recipient: testRecipient } }}</span>
    </div>

    <div class="dsp-section">
      <span class="dsp-label" id="send-mode-label">{{ 'proposals.dialogs.sendProposal.recipientsLabel' | transloco }}</span>
      <div class="dsp-segmented" role="radiogroup" aria-labelledby="send-mode-label">
        <button type="button" role="radio" class="dsp-segment" data-testid="send-mode-clients"
          [class.dsp-segment-active]="mode === 'clients'" [attr.aria-checked]="mode === 'clients'"
          (click)="selectMode('clients')">{{ 'proposals.dialogs.sendProposal.modeClients' | transloco }}</button>
        <button type="button" role="radio" class="dsp-segment" data-testid="send-mode-internal"
          [class.dsp-segment-active]="mode === 'internal'" [attr.aria-checked]="mode === 'internal'"
          (click)="selectMode('internal')">{{ 'proposals.dialogs.sendProposal.modeInternal' | transloco }}</button>
      </div>
    </div>

    <div *ngIf="mode === 'clients'" class="dsp-section" data-testid="send-clients-panel">
      <ng-container *ngIf="data.clients?.length; else noClients">
        <div class="dsp-list-head">
          <span class="dsp-count" data-testid="send-selected-count">
            {{ 'proposals.dialogs.sendProposal.selectedCount' | transloco: { selected: selectedClientIds.length, total: data.clients.length } }}
          </span>
          <button *ngIf="data.clients.length > 1" type="button" class="dsp-link" data-testid="send-select-all" (click)="toggleAllClients()">
            {{ (allClientsSelected ? 'proposals.dialogs.sendProposal.clearAll' : 'proposals.dialogs.sendProposal.selectAll') | transloco }}
          </button>
        </div>
        <ul class="dsp-client-list">
          <li *ngFor="let link of data.clients">
            <label class="dsp-client-row" [class.dsp-client-row-checked]="selectedClientIds.includes(link.client.id)">
              <input
                type="checkbox"
                class="dsp-checkbox"
                [id]="'send-client-' + link.client.id"
                [checked]="selectedClientIds.includes(link.client.id)"
                (change)="toggleClient(link.client.id)">
              <span class="dsp-client-name">{{ link.client.name }}</span>
            </label>
          </li>
        </ul>
      </ng-container>
      <ng-template #noClients>
        <p class="dsp-empty" data-testid="send-no-clients">{{ 'proposals.dialogs.sendProposal.noClients' | transloco }}</p>
      </ng-template>
    </div>

    <div *ngIf="mode === 'internal'" class="dsp-section" data-testid="send-internal-panel">
      <label class="dsp-label" for="send-internal-email">{{ 'proposals.dialogs.sendProposal.internalEmailLabel' | transloco }}</label>
      <input
        class="dsp-input"
        id="send-internal-email"
        type="email"
        autocomplete="email"
        data-testid="send-internal-email"
        [placeholder]="'proposals.dialogs.sendProposal.internalEmailPlaceholder' | transloco"
        [(ngModel)]="internalEmail"
        [ngModelOptions]="{standalone: true}"
        (keydown.enter)="confirm()">
    </div>

    <div *ngIf="errorMessage" class="dsp-alert" role="alert" data-testid="dialog-error">{{ errorMessage }}</div>
  </div>

  <div class="dsp-foot">
    <button type="button" class="dsp-btn dsp-btn-outline" (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="dsp-btn dsp-btn-primary" data-testid="send-confirm" (click)="confirm()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
      {{ 'proposals.dialogs.sendProposal.confirm' | transloco }}
    </button>
  </div>

</div>
